const region = process.env.VUE_APP_SITE_REGION || 'cn';
const rootDomain = region === 'com' ? 'taiyipan.com' : 'taiyipan.cn';
const siteUrl = `https://fs.${rootDomain}/`;
const mainSiteUrl = `https://www.${rootDomain}/`;

const buildStationUrl = (subdomain) => `https://${subdomain}.${rootDomain}/`;

export const siteConfig = {
  region,
  isCn: region === 'cn',
  isCom: region === 'com',
  siteUrl,
  mainSiteUrl,
  hostLabel: region === 'cn' ? 'TaiyiPan.cn' : 'TaiyiPan.com',
  supportEmail: 'contact@taiyipan.com',
  records: {
    icp: '豫ICP备2023021170号-2',
    icpUrl: 'https://beian.miit.gov.cn/',
    public: '豫公网安备41038102000315号',
    publicUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41038102000315'
  },
  stationLinks: [
    { key: 'home', label: '太一盘', href: mainSiteUrl },
    { key: 'bazi', label: '八字', href: buildStationUrl('bazi') },
    { key: 'huangli', label: '黄历', href: buildStationUrl('huangli') },
    { key: 'fengshui', label: '风水', current: true },
    { key: 'qimen', label: '奇门', href: buildStationUrl('qimen') },
    { key: 'liuyao', label: '六爻', href: buildStationUrl('liuyao') }
  ]
};
